import { Component } from '@angular/core';
import { Skeleton } from 'excellence-ui';

@Component({
  selector: 'app-supplier-contract-price-total-card-skeleton',
  imports: [Skeleton],
  templateUrl: './supplier-contract-price-total-card-skeleton.html',
})
export class SupplierContractPriceTotalCardSkeleton {}
